import { getImageThumbnailUrl } from '@/utils/getImageThumbnailUrl';
import { MEDIA_TYPES } from '@/utils/constants';
import { PlayIcon } from '@/assets/svgExports/PlayIcon';
import { ShareIcon } from '@/assets/svgExports/ShareIcon';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Slider } from '@/components/ReactSlickCarousel';
import useSetImagesDescriptionModal from '../../../../hooks/useSetImagesDescriptionModal';
import {
  ShareActionsContainer,
  ShareIconContainer,
} from '../DesktopImageComponent/DesktopImageComponent.styles';
import { MobilePdpImage, MobilePdpPlayIconContainer } from './MobileImageCompnent.styles';
import { copyTextToClipboard } from '../../../../utils/generateShareableURLS';
import { toastNotifySuccess } from '../../../../components/Common/Toast';
import {
  getSrcSetFromCompressedImages,
  imgSizeEnums,
} from '../../../../utils/compressedImagesHelpers';
import { MediaContainer } from 'src/components/ProductMediaRenderer/MediaContainer';
const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
};

const getSliderStyles = (aspectRatio, isCustomWebsite) => {
  const sliderStyles = {
    width: '100vw',
    // height: 380,
    marginBottom: 16,
  };
  // if (aspectRatio > 100 && isCustomWebsite) {
  //   sliderStyles.height = 220;
  // }
  // if (aspectRatio < 100 && isCustomWebsite) {
  //   sliderStyles.height = 674;
  // }
  return sliderStyles;
};

function MobileImageComponent(props) {
  const [isCopied, setIsCopied] = useState(false);
  const { activeIdx, productData, handleShowImageDescriptionModal, showImageDescModal } =
    props;

  const { theme } = useSelector((state) => ({
    theme: state.storeReducer.store.theme,
  }));
  const carouselRef = useRef(null);
  const images = useSetImagesDescriptionModal({
    productData,
    activeIdx,
    showImageDescModal,
  });
  const sliderStyles = getSliderStyles(
    theme?.product_aspect_ratio,
    theme?.custom_theme_flag
  );

  useEffect(() => {
    if (carouselRef.current?.slickGoTo) carouselRef.current.slickGoTo(0);
  }, [activeIdx]);

  function handleImageClick(e, item) {
    props?.setMainImageIndexFromPdp(
      images.findIndex((imageData) => imageData?.image_url === item?.image_url)
    );
    handleShowImageDescriptionModal();
  }
  const handleNativeShare = async () => {
    const contentForSharing = {
      title: productData?.name,
      url: window?.location?.href,
    };
    try {
      if (navigator.share) {
        await navigator.share(contentForSharing);
      } else {
        copyTextToClipboard(window.location.href, setIsCopied);
        isCopied && toastNotifySuccess('Link is copied!!');
        console.warn('Web Share API not supported');
      }
    } catch (err) {
      copyTextToClipboard(window.location.href, setIsCopied);
      isCopied && toastNotifySuccess('Link is copied!!');
      console.error('Error Sharing', err);
    }
  };

  return (
    <>
      <meta property="image" content={getImageThumbnailUrl(images[0], false)} />
      <Slider style={sliderStyles} {...settings} ref={carouselRef}>
        {images.map((item) => {
          let imageUrl = item?.image_url;
          if (item?.media_type === MEDIA_TYPES.YOUTUBE_VIDEO) {
            imageUrl = getImageThumbnailUrl(item);
          }
          return (
            <div key={item.name}>
              <MediaContainer width="tw-max-h-[480px] tw-max-w-full">
                <ShareActionsContainer>
                  <ShareIconContainer onClick={handleNativeShare}>
                    <ShareIcon />
                  </ShareIconContainer>
                </ShareActionsContainer>
                {item?.media_type !== MEDIA_TYPES.VIDEO ? (
                  <MobilePdpImage
                    className="tw-h-full tw-w-full tw-object-contain"
                    src={imageUrl}
                    srcSet={getSrcSetFromCompressedImages(
                      item?.compressed_images,
                      imageUrl,
                      { minImgSize: imgSizeEnums.HIGH }
                    )}
                    alt="item"
                    onClick={(e) => handleImageClick(e, item)}
                  />
                ) : (
                  <img
                    src={item?.thumbnail_url || ''}
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                  />
                )}
                {(item?.media_type === MEDIA_TYPES.YOUTUBE_VIDEO ||
                  item?.media_type === MEDIA_TYPES.VIDEO) && (
                  <MobilePdpPlayIconContainer onClick={(e) => handleImageClick(e, item)}>
                    <PlayIcon width={64} height={64} />
                  </MobilePdpPlayIconContainer>
                )}
              </MediaContainer>
            </div>
          );
        })}
      </Slider>
    </>
  );
}

export default MobileImageComponent;
